module.exports = __webpack_public_path__ + "static/media/Montserrat-Italic.df17124c.ttf";